

import {useState} from 'react';
import './App.css';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import HomePage from './Pages/Home';
import DeployedProjects from './Pages/DeployedProjects';
import Header from './Components/Header/Header';
// import About from './Pages/About';
import AboutMe from './Pages/AboutMe';
import { useMediaQuery, Box, createTheme, ThemeProvider} from '@mui/material';
import ScrollToTop from "react-scroll-to-top";
import Footer from './Components/Footer';
import Articles from './Pages/Articles';
import Speaking from './Pages/Speaking';
import TidyNestProjectInformation from './Pages/TidyNestProjectInformation';
import YouTubeVideos from './Pages/Videos';
import CommunityImpact from './Pages/Community';
import CommunityDetail from './Pages/CommunityDetails';
import MeenatAIProjectInformation from './Pages/MeenatAIProjectInformation';

function App() {
  // default theme: light mode is true
    const [theme, setTheme] = useState(true);
  //
  const desktopView = useMediaQuery('(min-width:1024px)');

   // to toggle current theme
        const changeTheme =()=>{
            setTheme(!theme)
            // alert(theme);
            localStorage.setItem('light-theme-mode', theme);
        }
        //
      const customTheme = createTheme({
        typography: {
          fontFamily: 'Raleway',
        },
          theme_pallete: {
            primary_color: `${theme ? 'black' : 'green'}`,
            secondary_color: `${theme ? 'white' : '#0a2351'}`,
            primary_color2: `${theme ? '#696969' : 'red'}`,
            secondary_color2: `${theme ? '#DCDCDC' : '#002244'}`,
          },
      });

  return (
    <ThemeProvider theme={customTheme}>
        <div className="App">
          <BrowserRouter>
              <Header lightTheme={theme} onToggle={changeTheme}/>
              <Box className={ desktopView ? 'body-desktop-container' : null} >
                <Routes>
                  <Route exact path='/' element={<HomePage/>}/>
                  <Route path='/about' element={<AboutMe/>}/>
                  <Route path='/projects' element={<DeployedProjects/>}/>
                  <Route path='/speaking' element={<Speaking/>}/>
                  <Route path='/tidynest-project-information' element={<TidyNestProjectInformation/>}/>
                    <Route path='/meenatai-project-information' element={<MeenatAIProjectInformation/>}/>
                  {/* <Route path='/hands-on' element={<Handson/>}/> */}
                  <Route path='/articles' element={<Articles/>}/>
                  <Route path='/videos' element={<YouTubeVideos/>}/>
                  <Route path='/community' element={<CommunityImpact/>}/>
                  <Route path='/community-details/:id' element={<CommunityDetail/>}/>
              </Routes>
              <ScrollToTop smooth color='black' top='20' style={{marginBottom:'10px'}}/>
              {/* <AIChatbot/> */}
              <Footer/>
              </Box>
          </BrowserRouter>
        </div>
    </ThemeProvider>
  );
}

export default App;
